import { RootState } from '@reducers';

export const selectCorporateHealthClaim = (state: RootState) =>
  state.userDashboardRouteReducer.claimDetails.corporateHealthClaimDetails;
